import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { PublicPageCard } from '../shared'
import HousefoliosUser from '@/assets/images/Housefolios_user.png'
import ExpandableText from './ExpandableText'

/**
 * Team member card on public marketplace /team pages.
 */
const TeamMemberCard = ({ teamMember }) => {
  const { userImage, profile, jobTitle, bioDescription } = teamMember
  const name = [profile?.firstname, profile?.lastname]
    .filter(Boolean)
    .join(' ')
    .trim()

  return (
    <PublicPageCard alignItems="flex-start">
      <Grid size={{ xs: 12, md: 3 }}>
        <Box
          sx={{
            mx: 'auto',
            width: 200,
            height: 200,
            borderRadius: '50%',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Box
            component="img"
            src={userImage?.url || HousefoliosUser}
            alt={name || 'Team Member'}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'top center',
              borderRadius: '50%',
            }}
          />
        </Box>
      </Grid>

      <Grid size={{ xs: 12, md: 9 }}>
        {name ? (
          <Typography variant="h5" component="h2" gutterBottom>
            {name}
          </Typography>
        ) : null}
        {jobTitle ? (
          <Typography variant="subtitle1" sx={{ color: '#1fa7e8' }}>
            {jobTitle}
          </Typography>
        ) : null}
        {bioDescription ? (
          <ExpandableText
            text={bioDescription}
            maxLines={5}
            sx={{ px: 0, py: 0, mt: 1.25 }}
          />
        ) : null}
      </Grid>
    </PublicPageCard>
  )
}

export default TeamMemberCard
